import { DocumentViewPageController } from './documents-view-page.controller';

export const DocumentsView = () => {
  return <DocumentViewPageController />;
};
